
import { Vue, Component } from 'vue-property-decorator';
import { Action } from 'vuex-class';
import { Base64 } from 'js-base64';
import { IUSER, ISET } from '@/types/app.d';
import api from '@/api/app';
import { LOGIN_SET } from './login';
import tInput from './components/t-Input/index.vue';
import tButton from './components/t-Button/index.vue';

@Component({
  components: {
    tInput,
    tButton,
  },
})
export default class Login extends Vue {
  /* eslint-disbale no-underscore-dangle */
  @Action('user/login') _login!: Function

  private set: ISET = LOGIN_SET;

  private loginLoad: Boolean = false;

  private userForm: IUSER = { user: '', pass: '' };

  public $refs!: {
    user: tInput,
    pass: tInput,
  }

  // 登录
  login() {
    if (this.loginLoad) return;
    this.loginLoad = true;
    if (this.$refs.user.validate() && this.$refs.pass.validate()) {
      /* eslint-disable no-underscore-dangle */
      api.login(this.userForm).then((res: any) => {
        this._login({
          auth: { token: res.token.accessToken, time: res.token.expiresTime },
          menuRoutes: res.menus.filter((menu: any) => menu.type === 'MENU').map((menu: any) => ({
            id: menu.id,
            path: menu.path,
          })),
          btns: res.menus.filter((menu: any) => menu.type === 'BUTTON').map((menu: any) => Base64.encode(menu.path)),
        }).then(() => window.location.reload());
      }).catch(() => { this.loginLoad = false; });
    } else this.loginLoad = false;
  }
}
